import Link from "next/link";
import type { ReactNode } from "react";

export const ItemTitle = ({ children }: Readonly<{ children: ReactNode }>) => {
  return <h2 className="text-xl text-justify font-bold text-white">{children}</h2>;
};

export const ItemBody = ({
  children,
  link,
}: Readonly<{ children: ReactNode; link: string }>) => {
  return (
    <p className="text-md mt-2 leading-5 font-light text-gray-300">
      <span className="opacity-70 text-sm">
        {children}
      </span>
      <br />
      <Link href={link} className="text-blue-400 mx-1 hover:underline">
        ادامه مطلب...
      </Link>
    </p>
  );
};
